"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _Avatar = _interopRequireDefault(require("./Avatar.styles"));
var _Avatar2 = require("./Avatar.helpers");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Avatar = function Avatar(props) {
  var firstName = props.firstName,
    lastName = props.lastName,
    _props$startBy = props.startBy,
    startBy = _props$startBy === void 0 ? 'FirstName' : _props$startBy,
    ariaHidden = props.ariaHidden;
  var _getAvatar = (0, _Avatar2.getAvatar)(props),
    avatar = _getAvatar.avatar,
    initials = _getAvatar.initials;
  var styles = (0, _Avatar.default)(props, avatar);
  var fullName = startBy === 'FirstName' ? firstName + ' ' + lastName : lastName + ' ' + firstName;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Avatar'],
    children: [initials && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: initials
    }), avatar && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "img",
      "aria-label": fullName,
      className: styles['cc-Avatar__image'],
      "aria-hidden": ariaHidden
    })]
  });
};
exports.Avatar = Avatar;